module.exports = __webpack_public_path__ + "img/thai-baht.bc6c5eed.png";